export default __webpack_public_path__ + "static/media/company-default.4fcc324f.svg";